export const _textBannerClass = {
  name: { type: 'string', title: 'Bannerin nimi' },
  start: {
    type: 'string',
    format: 'date',
    title: 'Ensimmäinen päivä jossa näkyy',
  },
  end: {
    type: 'string',
    format: 'date',
    title: 'Viimeinen päivä jossa näkyy',
  },
  state: {
    type: 'string',
    title: 'Tila',
    oneOf: [
      { const: 'active', title: 'Aktiivinen' },
      { const: 'paused', title: 'Pysäytetty' },
    ],
  },
  format: {
    type: 'string',
    title: 'Muoto',
    oneOf: [
      { const: 'info', title: 'Infoteksti' },
      { const: 'textad', title: 'Mainos' },
    ],
  },
  content: { type: 'string', title: 'Teksti, max 280 merkkiä' },
  sections: {
    type: 'string',
    title: 'Missä näkyy',
    oneOf: [
      { const: 'all', title: 'Kaikkialla' },
      { const: 'reservations', title: 'Varausnäkymä' },
      { const: 'activities', title: 'Aktiviteettinäkymä' },
    ],
  },
  categories: {
    type: 'string',
    format: 'string',
    title: 'Varausnäkymän kategoriat. Erottele pilkulla. Tyhjä = kaikki',
  },
}

export const _textBannerClassDeps = {
  format: {
    oneOf: [
      {
        properties: {
          format: {
            enum: ['info'],
          },
        },
      },
      {
        properties: {
          format: {
            enum: ['textad'],
          },
          linktitle: {
            type: 'string',
            title: 'Otsikko',
          },
          link: {
            type: 'string',
            title: 'Linkki',
          },
          externalctt: {
            type: 'string',
            title: 'Ulkoinen clickthrough linkki',
          },
        },
      },
    ],
  }
}

export const _textBannerUISchema = {
  content: {
    'ui:widget': 'textarea',
  },
}
